<clr-datagrid class="datagrid-compact" [clrDgRowSelection]="false">

  <clr-dg-action-bar>
    <!-- <a #download class="btn btn-sm btn-secondary" href="" (click)="downloadList()" download="products.csv">Свали
      списък</a> -->
  </clr-dg-action-bar>

  <clr-dg-column [clrDgField]="'print.PrintTime'">Дата</clr-dg-column>
  <clr-dg-column [clrDgField]="'print.PrintUser'">Потребител</clr-dg-column>
  <clr-dg-column [clrDgField]="'print.Description'">Описание</clr-dg-column>
  <clr-dg-column [clrDgField]="'print.DocumentPrintImage.PrintoutLayout.Name'">Тип</clr-dg-column>

  <clr-dg-row *clrDgItems="let print of prints" [clrDgItem]="print">
    <clr-dg-cell>{{print.PrintTime | date:'short'}}</clr-dg-cell>
    <clr-dg-cell>{{print.PrintUser}}</clr-dg-cell>
    <clr-dg-cell>{{print.Description}}</clr-dg-cell>
    <clr-dg-cell>{{print?.DocumentPrintImage?.PrintoutLayout?.Name}}</clr-dg-cell>
  </clr-dg-row>
</clr-datagrid>